<div id="dst-system-lock-unlock" class="shutdown-dst-app-container">
  <h3 class="aligned-center">DST Shutdown and QAR process</h3>
  <br />

  <div class="main-content">
    <div class="form-row">
      <span class="form-label aligned-center">Click the Button to Lock/Unlock the system:</span>
      <div class="form-value-col">
        <button
          class="submit-button"
          type="button"
          [disabled]="savingLock"
          (click)="saveLockUnlock()">
          System {{ isLocked === "0" ? "Lock" : "Unlock" }}
          @if (savingLock) {
<span><i class="fa fa-spinner fa-spin"></i></span>
}
        </button>
      </div>
    </div>
  </div>
</div>
